import React from 'react';
import { useTheme } from '../../../theme/ThemeContext';
import { ShieldIcon } from '../icons';

const ChatLogo = ({ isLoading = false }) => {
  const { theme, currentTheme } = useTheme();

  return (
    <div className={`logo-wrapper ${isLoading ? 'loading' : ''}`}>
      <img
        src={theme.logo.image}
        alt="App Logo"
        className="app-logo"
        loading="lazy"
        key={currentTheme}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
      <div className="logo-placeholder" style={{ display: 'none' }}>
        <ShieldIcon size={32} />
      </div>
    </div>
  );
};

export default ChatLogo;
